<template>
  <img
    class="carrier-logo"
    :style="{ width: `${size}px`, height: `${size}px` }"
    alt=""
    :src="failed || !src ? placeholder : src"
    @error="failed = true"
  />
</template>

<script>
import { CARRIER_PLACEHOLDER } from '@/utils/carrierCatalog';

/**
 * A carrier's logo, square and rounded, as All updates shows it on each row and in its filter.
 *
 * Without a logo, or with one that does not load (a saved URL gone stale), the neutral carrier
 * placeholder — never a broken image.
 */
export default {
  name: 'CarrierLogo',
  props: {
    src: { type: String, default: null },
    size: { type: Number, default: 28 },
  },
  data() {
    return { failed: false, placeholder: CARRIER_PLACEHOLDER };
  },
  watch: {
    src() { this.failed = false; },
  },
};
</script>

<style lang="scss" scoped>
.carrier-logo {
  flex: none;
  border-radius: 6px;
  object-fit: contain;
  background: #fff;
  box-shadow: 0 0 0 1px var(--solid-lavender-grey);
}
</style>
